import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Header from "../components/Header";  // ✅ Header 정의됨

// 이미지 파일
import img4 from '../assets/vision1.png';
import img5 from '../assets/vision2.png';
import img6 from '../assets/vision3.png';

// SVG 아이콘 파일
import { ReactComponent as CommentsIcon }   from '../assets/icons/comments.svg';
import { ReactComponent as GlassIcon }      from '../assets/icons/glass.svg';
import { ReactComponent as PaintBrushIcon } from '../assets/icons/paintbrush.svg';
import { ReactComponent as TreeIcon }       from '../assets/icons/tree.svg';
import { ReactComponent as LetterIcon }     from '../assets/icons/letter.svg';
import { ReactComponent as ComputerIcon }   from '../assets/icons/computer.svg';
import { ReactComponent as BookIcon }       from '../assets/icons/book.svg';
import { ReactComponent as IslandIcon }     from '../assets/icons/island.svg';
import { ReactComponent as MovieIcon }      from '../assets/icons/movie.svg';
import { ReactComponent as CommunityIcon }  from '../assets/icons/community.svg';
import { ReactComponent as LectureIcon }    from '../assets/icons/lecture.svg';
import { ReactComponent as CakeIcon }       from '../assets/icons/cake.svg';

// 스타일
import './Home.css';

export default function Home() {
  const navigate = useNavigate();
  return (
    <>
      <Header />

      {/* 상단 배경 섹션 */}
      <div className="hero-section">
        <h1 className="main-title">에버영라이프</h1>
          <div className="sub-title boxed">
            <div className="boxed-content">
              {/* 데스크톱 전용(현재처럼 3줄) */}
              <p className="only-desktop hero-txt">
                <span className="nb">시니어의 건강, 사회적 관계, 정신적인 만족까지 모두 아우르는 매우 매력적인 복합 라이프케어</span><br/>
                에버영라이프(EverYoung Life)는 시니어들의 신체적·정신적 건강, 사회적 연결,<br/>
                그리고 삶의 질을 높이는 모임입니다
              </p>

              {/* 모바일 전용(원하는 위치로 줄바꿈 고정) */}
              <p className="only-mobile hero-txt">
                <span className="nb">시니어의 건강, 사회적 관계, 정신적인 만족까지</span><br/>
                <span className="nb">모두 아우르는 매우 매력적인 복합 라이프케어</span><br/>
                <span className="nb">에버영라이프(EverYoung Life)는 시니어들의</span><br/>
                신체적·정신적 건강, 사회적 연결, 그리고<br/>
                 삶의 질을 높이는 모임입니다
              </p>
            </div>
          </div>

          <button
          className="go-button"
          onClick={() => navigate("/apply")}
         >
          신청하기
        </button>
      </div>

      

          {/* 목표 및 비전 섹션 */}
    <section className="vision-section section-divider">
      
        {/* 데스크탑용 */}
    <div className="only-desktop vision-txt">
      <p className="feature-subtitle">에버영라이프 목표 및 비전</p>
      <h2 className="feature-title">시니어들이 건강한 식습관, 지속적인 학습, 적절한 운동을 통해 의미있는 여생을 보내도록 커뮤니티 구축</h2>

      <div className="vision-images">
        <div className="vision-item">
          <div className="vision-img">
            <img src={img4} alt="식습관" />
          </div>
          <p className="vision-caption">신체적,정신적,사회적 건강을 증진하는 활동 제공</p>
        </div>

        <div className="vision-item">
          <div className="vision-img">
            <img src={img5} alt="여행" />
          </div>
          <p className="vision-caption">시니어들간의 네트워킹과 소속감 형성</p>
        </div>

        <div className="vision-item">
          <div className="vision-img">
            <img src={img6} alt="학습" />
          </div>
          <p className="vision-caption">긍정적이고 활기찬 노년 문화 조성</p>
        </div>
      </div>

      <p className="vision-extra">핵심 가치: 건강, 학습, 연결, 즐거움, 자율성</p>
    </div>

    {/* 모바일용 */}
    <div className="only-mobile vision-txt">
      <span className="nb"><p className="feature-subtitle">에버영라이프 목표 및 비전</p></span>
      <h2 className="feature-title">
        시니어들이 건강한 식습관,<br/>지속적인 학습, 적절한 운동을 통해<br/>의미있는 여생을 보내도록<br/>커뮤니티 구축
      </h2>

      <div className="vision-images">
        <div className="vision-item">
          <div className="vision-img">
            <img src={img4} alt="식습관" />
          </div>
          <p className="vision-caption">신체적,정신적,사회적 건강을<br/>증진하는 활동 제공</p>
        </div>

        <div className="vision-item">
          <div className="vision-img">
            <img src={img5} alt="여행" />
          </div>
          <p className="vision-caption">시니어들간의 네트워킹과<br/>소속감 형성</p>
        </div>

        <div className="vision-item">
          <div className="vision-img">
            <img src={img6} alt="학습" />
          </div>
          <p className="vision-caption">긍정적이고 활기찬 노년 문화 조성</p>
        </div>
      </div>

      <p className="vision-extra">핵심 가치: 건강, 학습, 연결, <br/>즐거움, 자율성</p>
    </div>

    </section>


        {/* 회원 기준 섹션 */}
    <section className="feature-section section-divider">

      {/* 데스크탑용 */}
      <div className="only-desktop feature-txt">
        <p className="feature-subtitle">에버영라이프 회원 기준</p>

        <div className="feature-box-grid">
          {/* box-top과 box-bottom을 같은 grid 안에 배치 */}
          <div className="box-top">
            {/* 1. 참여조건 */}
            <div className="feature-box center">
              <span className="blue">1. 참여조건:</span>
              <ul className="feature-box-list">
                <li>
                  에버영라이프 신청자
                  <span className="subtext">(시니어 이외 가능)</span>
                </li>
              </ul>
            </div>

            {/* 2. 참여대상 */}
            <div className="feature-box highlight">
              <span className="blue">2. 참여대상:</span>
              <ul className="feature-box-list">
                <li>
                  <span className="op-keyword">관심사:</span> 건강관리, 저속노화, 자기계발, 사회적 교류에 관심 있는 분
                </li>
                <li>
                  <span className="op-keyword">건강 상태:</span> 일상생활 전반 중 신체적인 활동이 무리 없이 가능한 분
                </li>
                <li>
                  <span className="op-keyword">동기:</span> 커뮤니티 참여활동에 적극적이고 긍정적 기여 의지를 가진 분
                </li>
              </ul>
            </div>
          </div>

          <div className="box-bottom">
            {/* 3. 모집절차 */}
            <div className="feature-box wide">
              <span className="blue">3. 모집절차:</span>
              <ul className="no-bullet">
                <li>
                  신청서 작성 → 오리엔테이션 참석 → 시범 활동 참여 → 정회원 가입
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    
      {/* 모바일용 */}
      <div className="only-mobile feature-txt">
        <p className="feature-subtitle">에버영라이프 회원 기준</p>
      <div className="feature-box-grid">

        {/* 1. 참여조건 */}
        <div className="feature-box center">
          <span className="blue">1. 참여조건:</span>
          
          <ul className="feature-box-list">
            <li>
              에버영라이프 신청자<br />
              <span className="subtext">(시니어 이외 가능)</span>
            </li>
          </ul>
        </div>

        {/* 2. 참여대상 */}
        <div className="feature-box highlight">
          <span className="blue">2. 참여대상:</span>
          <ul className="feature-box-list">
            <li>
              <span className="op-keyword">관심사:</span><br />
              건강관리, 저속노화,<br /> 
              자기계발, 사회적 교류<br />
              관심 있는 분
            </li>
            <li>
              <span className="op-keyword">건강 상태:</span><br />
              일상생활 전반에 걸쳐<br />
              신체적인 활동이 무리<br />
              없이 가능한 분
            </li>
            <li>
              <span className="op-keyword">동기:</span><br />
              커뮤니티 참여활동에<br />
              적극적이고  긍정적<br />
              기여 의지를 가진 분
            </li>
          </ul>
        </div>

        {/* 3. 모집절차 */}
        <div className="feature-box wide">
          <span className="blue">3. 모집절차:</span>
          <ul className="no-bullet">
            <li>
              신청서 작성<br />
              → 오리엔테이션 참석<br />
              → 시범 활동 참여<br />
              → 정회원 가입
            </li>
          </ul>
        </div>
      </div>
    </div>
    </section>


{/* 주요 프로그램 섹션 */}
<section className="programs-section section-divider">
  {/* 데이터 정의(순서: comments, glass, paintbrush, tree, letter, computer, book, island, movie, community, lecture, cake) */}
  {(() => {
    const programs = [
      // 1 ~ 12월 (제목=프로그램명, desc=자세한 내용)
      { slug: 'dialogue', Icon: CommentsIcon,  title: '나만의 루틴 선언식',       desc: '•새해 루틴 설계 워크숍·선언식 \n •서로의 계획 나눔'},
      { slug: 'health-check', Icon: GlassIcon, title: '다이닝 콘서트',            desc: '•식사와 대화로 공감 나눔\n •취향·문화 이야기' },
      { slug: 'art-museum', Icon: PaintBrushIcon, title: '예술로 대화하기',     desc: '•전시 관람과 감상 토론\n •아트테라피 체험' },
      { slug: 'walking', Icon: TreeIcon,        title: '둘레길로 걷기',       desc: '•봄철 둘레길 걷기\n •명상하고 추억 공유' },
      { slug: 'letter', Icon: LetterIcon,       title: '가족에게 쓰는 편지',       desc: '•가족·자녀에게 마음 전하기\n •낭독과 대화 시간' },
      { slug: 'digital-life', Icon: ComputerIcon, title: 'ChatGPT와 살아보기',    desc: '•ChatGPT 활용 실습\n •실습 사례 공유와 Q&A' },
      { slug: 'book-club', Icon: BookIcon,      title: '인생 책장 & 독서 토론',     desc: '•각자의 인생 책 소개\n •독후감 발표와 토론' },
      { slug: 'island-trip', Icon: IslandIcon,  title: '국내 섬 여행 & 섬다도',     desc: '•당일 섬예행 출발\n •섬 문화 체험 계획' },
      { slug: 'movie-talk', Icon: MovieIcon,    title: '내가 사랑한 영화',        desc: '•추천 영화 감상과 대화\n •비평 기사 작성 체험' },
      { slug: 'community-give', Icon: CommunityIcon, title: '회원의 재능기부날', desc: '•회원 재능·경험 공유\n •노래, 글, 사진 등' },
      { slug: 'vocation-talk', Icon: LectureIcon, title: '명사 초청 인생토크',    desc: '•삶의 의미·노화·희망 관한 강연\n •강연 후 인터뷰' },
      { slug: 'closing-party', Icon: CakeIcon,  title: '송년회 & 루틴 어워드',       desc: '•한 해를 결산 후 회고\n •활동 시상·장기참여자 인증' },
    ];

    // 4개씩 끊어 데스크탑 줄(3줄) 만들기
    const chunk = (arr, size) =>
      arr.reduce((acc, _, i) => (i % size ? acc : [...acc, arr.slice(i, i + size)]), []);

    const rows = chunk(programs, 4);

    return (
      <>
        {/* 데스크탑용: 4개씩 3줄 */}
        <div className="only-desktop">
          <p className="feature-subtitle">에버영라이프 12개월 운영프로그램</p>
          {rows.map((row, rIdx) => (
            <div className="program-list" key={`row-${rIdx}`}>
              {row.map(({ slug, Icon, title, desc }) => (
                <div className="program-item" key={slug}>
                  <Link to={`/program/${slug}`} className="program-icon" aria-label={title}>
                    <Icon />
                  </Link>
                  <div className="program-desc">
                    <h3>{title}</h3>
                    <p className="desc-text">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* 모바일용: 기존 스타일 유지(세로 스택) */}
        <div className="only-mobile">
          <p className="feature-subtitle">에버영라이프 주요<br /> 프로그램</p>
          <div className="program-list-mobile">
            {programs.map(({ slug, Icon, title, desc }) => (
              <div className="program-item" key={`m-${slug}`}>
                <Link to={`/program/${slug}`} className="program-icon" aria-label={title}>
                  <Icon />
                </Link>
                <div className="program-desc">
                  <h3>{title}</h3>
                  <p className="desc-text">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </>
    );
  })()}
</section>
</>
  );
}
